import { CustomerInformation } from 'app/page/orders/model/customer-information';
import { customerService } from 'app/api/service/customer-service';
import { CustomerMapper } from 'app/page/orders/mapper/customer-mapper';

class CustomerService {
    public static getCustomerInformation(partnerId: string, billingAccountId: string): Promise<CustomerInformation> {
        return customerService
            .getCustomerInformation(partnerId, billingAccountId)
            .then((customerInformation) => CustomerMapper.mapCustomerInformation(partnerId, customerInformation));
    }
}

export { CustomerService };
